export interface DragHandlers {
  onMove?(e: PointerEvent): void
  /** Called on pointerup. Not called when the drag is canceled. */
  onUp?(e: PointerEvent): void
  /** Escape pressed or the pointer canceled. */
  onCancel?(): void
}

/**
 * Track a drag on the window so it survives the pointer leaving the viewport,
 * and always tears down exactly once.
 */
export function startDrag(handlers: DragHandlers): () => void {
  let done = false

  const cleanup = () => {
    if (done) return
    done = true
    window.removeEventListener('pointermove', move)
    window.removeEventListener('pointerup', up)
    window.removeEventListener('pointercancel', cancel)
    window.removeEventListener('keydown', key, true)
  }

  function move(e: PointerEvent) {
    handlers.onMove?.(e)
  }
  function up(e: PointerEvent) {
    cleanup()
    handlers.onUp?.(e)
  }
  function cancel() {
    cleanup()
    handlers.onCancel?.()
  }
  function key(e: KeyboardEvent) {
    if (e.key !== 'Escape') return
    e.preventDefault()
    e.stopPropagation()
    cancel()
  }

  window.addEventListener('pointermove', move)
  window.addEventListener('pointerup', up)
  window.addEventListener('pointercancel', cancel)
  window.addEventListener('keydown', key, true)

  return cancel
}
